import dayjs from "dayjs";

type DateUnit = 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second';

export function countryToFlag(isoCode: string) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char: any) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : isoCode;
}

export const formatReceivedDate = (date: any) => {
  if (dayjs(date).isValid()) {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    if (dayjs(formattedDate).isValid()) {
      return formattedDate;
    }
  }
  return "";
};

export const formatNumber = (number: number, n: number) => {
  const formattedNumber = number.toFixed(n);
  
  if (parseFloat(formattedNumber) === number) {
    return number;
  } else {
    return formattedNumber;
  }
}

export const formatDateDifference = (date1: string, date2: string) => {
  const dateUnits: Array<DateUnit> = ['year', 'month', 'day', 'hour', 'minute', 'second'];
  for (let i = 0; i < dateUnits.length; i++) {
    let duration = dayjs(date1).diff(date2, dateUnits[i]);
    if (duration > 0) {
      return duration + ' ' + dateUnits[i] + 's';
    }
  }

  return "-";
}

export const getInputDateFormat = (lang: string) => {
  return lang === "en" ? "MM/dd/yyyy" : "dd.MM.yyyy";
};

export const isSubmitButtonEnabled = (
  touched: any,
  errors: any,
  keys: string[]
) => {
  return isBeforeFirstSubmitPress(touched) || noErrors(errors, keys);
};

export const defaultCountryAutocompleteOption = {
  label: "",
  code: "",
};

const isBeforeFirstSubmitPress = (touched: any) => {
  return (
    touched &&
    Object.keys(touched).length === 0 &&
    touched.constructor === Object
  );
};

const noErrors = (errors: any, keys: string[]): boolean => {
  return keys.filter((key) => errors[key]).length === 0;
};

export const createRequest = (allData: any, fields: Array<string>): any => {
  let data: any = {};

  Object.keys(allData).forEach((key) => {
    if (fields.includes(key) && allData[key] !== null) {
      data[key] = allData[key];
    }
  });

  return data;
}

export const prune = (oldObj: any) => {
  let newObj = Object.assign({}, oldObj);

  Object.keys(newObj).forEach((key) => {
    if(newObj[key] === undefined || newObj[key] === null) {
      delete newObj[key];
    }
  });

  return newObj;
}

export const toUpperCaseFirst = (text: string) : string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

